export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/57a43ba76340ea303ae7dc89733370a0.svg";